module.exports = __webpack_public_path__ + "img/tiktok-svgrepo-com.fe4d72aa.svg";